import { Component, Input, OnInit, Output, EventEmitter, AfterContentChecked } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-customize-dropdown',
  templateUrl: './customize-dropdown.component.html',
  styleUrls: ['./customize-dropdown.component.css']
})
export class CustomizeDropdownComponent implements OnInit {

  @Input() title = '';
  @Input() AllEventsList : any = [];    // all the dropdown options presents
  @Input() checkedEventsList : any = [];   // checked options array
  @Input() selectAllEnable : boolean = false;  // flag for allowing select All functionality
  @Input() statusAll : boolean = false;  // initial flag for setting All Enable / disable

  @Output() onApplyBtnClick = new EventEmitter< any >();
  
  customizeEventsForm : UntypedFormGroup;

  applyCheckedEventsList : any = [];
  hideEventsApply : boolean = false;
  // isApply: boolean;

  constructor( private notification: NotificationService ) { 

    this.customizeEventsForm = new UntypedFormGroup({
			["custom_events_select"] : new UntypedFormControl( [], [] )
		})	

  }

  ngOnInit() {
    this.applyCheckedEventsList = this.checkedEventsList;
  }
  ngAfterContentChecked() : void {
    this.statusAll = this.checkedEventsList.includes('all');
    this.applyCheckedEventsList = this.checkedEventsList;
    // this.statusAll = this.checkedEventsList.length >= this.AllEventsList.length;
  }
  onEventsChangeFunction( selectedEvents ){   // on selection of customize events dropdown checkbox
		this.checkedEventsList = selectedEvents;		
	}

  openCloseEventsChange(e){
		if( e === true  ){  // if popup opened show previosly selected
      
			this.checkedEventsList = this.applyCheckedEventsList;
      if(this.checkedEventsList.length >= this.AllEventsList.length){
        this.statusAll = true;
      }
      console.log( "  openCloseEventsChange , open ", this.checkedEventsList )
      
    }
    // else if(!this.isApply) {
    //   this.checkedEventsList = [];
    //   this.hideEventsApply = true;
    // }
	}

  onEventsCheckboxClick( event_num ){   // on click of events checkbox check max selection

    if( this.checkedEventsList.length != this.applyCheckedEventsList.length ){
      this.checkedEventsList = this.checkedEventsList.filter( item => ( item != 'all' ) )
      console.log( " after deleting ", this.checkedEventsList)
      this.statusAll = false;
    }

		if( this.checkedEventsList.length == 0 ){
			let eventsAlertMsg = "Please select atleast one option";
			this.notification.showError( eventsAlertMsg );
			this.hideEventsApply = true;
		}
		else{
			this.hideEventsApply = false;
		}

	}

  toggleAllSelection( e ) {
    this.statusAll = ! this.statusAll;

    if (this.statusAll ) {

      let selectAll = [ ...this.AllEventsList.map(item => item.v), "all" ];
      this.checkedEventsList = selectAll;
      this.hideEventsApply = false;
    } else {
      this.checkedEventsList = [];
      this.hideEventsApply = true;
      let eventsAlertMsg = "Please select atleast one option";
			this.notification.showError( eventsAlertMsg );
    }
  }

applyEvents( ){ 
   
    this.applyCheckedEventsList = this.checkedEventsList;

    let event_selected = '';
    // this.isApply = true;
    if( this.checkedEventsList.includes('all')  ){  // if all selected
      event_selected = 'all';
      this.statusAll = true;
      console.log('all selected');
    }
    else{
      for ( let i=0; i < this.checkedEventsList.length ; i++ ) {  // loop through
        event_selected += this.checkedEventsList[i]+"_";
      }
      event_selected = event_selected.slice(0, -1);
      this.statusAll = false;
    }

    let emitData = { list : this.checkedEventsList, fields : event_selected };

    //this.onApplyBtnClick.emit( this.checkedEventsList );
    this.onApplyBtnClick.emit( emitData );
  }

  changeStatusAllOption( status = false ){

    let currentStatus = this.applyCheckedEventsList;
    if( status ){   // to check option ALL
      
      currentStatus.push( "all" );
      //this.moreFiltersForm.controls['filter_sq_status_val_'+sq_num].patchValue( currentStatus );  
      this.checkedEventsList = currentStatus;
    }
    else{    // to uncheck option All
      this.statusAll = false;
      currentStatus = currentStatus.filter( item => ( item != 'all' ) )
      this.checkedEventsList = currentStatus;
      //this.moreFiltersForm.controls['filter_sq_status_val_'+sq_num].patchValue( currentStatus );
    }

  }
  getSelectedText(value){
    
    let tmpItem = this.AllEventsList.filter( item => (item.v == value));
    // console.log(tmpItem);
    if( tmpItem.length > 0 ){
      return tmpItem[0].n;
    } else {
      return '';
    }
    
  }

}
